/**
 * PageLayout - Layout standardizzato per tutte le pagine dell'applicazione
 * Gestisce il layout fisso, scroll controllato e responsive design
 */

import React, { useEffect, ReactNode } from 'react';
import { Box } from '@mui/material';

interface PageLayoutProps {
  children: ReactNode;
  disableBodyScroll?: boolean;
  padding?: number | string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  disableBodyScroll = true,
  padding = 2 
}) => {
  // Prevenire lo scroll della pagina se richiesto
  useEffect(() => {
    if (disableBodyScroll) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [disableBodyScroll]);

  return (
    <Box sx={{ 
      height: 'calc(100vh - 140px)', // Sottrae spazio per header e padding
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden',
      p: padding
    }}>
      {children}
    </Box>
  );
};

export default PageLayout;
